import React from 'react';
import PropTypes from 'prop-types';
import { UncontrolledTooltip } from 'reactstrap';

export default function TooltippedCel(props) {
	const TooltipId = `Tooltip-${parseInt(Math.random() * 1000000)}`;

	return (
		<span id={TooltipId}>
			<div>{props.text}</div>
			<UncontrolledTooltip placement={props.placement} target={TooltipId}>
				<div>{props.text}</div>
			</UncontrolledTooltip>
		</span>
	);
}

TooltippedCel.defaultProps = {
	text: '',
	placement: 'right-end',
};

TooltippedCel.propTypes = {
	text: PropTypes.string,
	placement: PropTypes.string,
};
